<template>
	<el-row class="container">
		
		<el-col :span="24" class="main">
			<aside :class="collapsed ? 'menu-collapsed':'menu-expanded'" >
				<!--logo-->
				<div style="height:64px;background:#F66B3D;">
					<!-- <img v-if="company_log" class="logo_img" :src="company_log" >
					<img v-else class="logo_img" src="./img/logoB.png" >
					<span v-if="company_name" class="logo_span">{{company_name}}</span>
					<span v-else class="logo_span">{{sysName}}</span> -->
					 <img :src="require('@/assets/logo.svg')" class="logo-img"  style="width: 200px; height: auto;margin-left:15px;"/>
				</div>
				<div style="height:250px;background:#fff;text-align:center;overflow:auto">
					<img class="home_img" v-if="photo" id="sz" :src= this.photo >
					<img class="home_img" v-else src="./img/login/head@2x.png"></br>
					<span class="home_span">{{sysUserName}}</span></br>
					<span class="home_company">{{ company }}</span></br>
					<span class="home_point">{{ point }}</span><span class="home_point1"> 积分</span>
				</div>
				<div class="cygn">
					<span style="position:relative;left:20px;">常用功能</span>
				</div>
				<!--导航菜单-->
				<el-menu :default-active="currentPath" class="el-menu-vertical-demo" 
					@open="handleopen" @close="handleclose" @select="handleselect" unique-opened router v-show="!collapsed">
							<el-menu-item class="icon_class"  index="management">
								<i class="iconfont icon-kongzhizhongxin" style="position:relative;left:5px;"></i>
								<span class="icon_span" slot="title">控制台</span>
							</el-menu-item>
							<el-menu-item class="icon_class"  index="productList">
								<i class="iconfont icon-wodechanpin" style="position:relative;left:5px;"></i>
								<span class="icon_span" slot="title">我的产品</span>
							</el-menu-item>
							<el-menu-item class="icon_class" index="accountList">
								<i class="iconfont icon-icon-" style="position:relative;left:5px;"></i>
								<span class="icon_span" slot="title">我的账户</span>
							</el-menu-item>
							<el-menu-item class="icon_class" index="companyAll"  v-show="companymanageid || deptList.length > 0">
								<i class="iconfont icon-shouquan" style="position:relative;left:5px;"></i>
								<span class="icon_span" slot="title">企业管理</span>
							</el-menu-item>
							<el-menu-item class="icon_class" index="integral">
								<i class="el-icon-coin" style="position:relative;left:0px;font-weight:bold"></i>
								<span class="icon_span" slot="title" style="left:0px">积分商城</span>
							</el-menu-item>
							<!-- <el-submenu index="1" v-show="companymanageid">
								<template slot="title">
									<i class="iconfont icon-shouquan" style="position:relative;left:5px;"></i>
									<span class="icon_span">企业管理</span>
								</template>
								<el-menu-item-group>
									<el-menu-item style="padding-left:65px;" index="company">企业用户</el-menu-item>
									<el-menu-item style="padding-left:65px;" index="weProduct">产品管理</el-menu-item>
									<el-menu-item style="padding-left:65px;" index="device">设备管理</el-menu-item>
									<el-menu-item style="padding-left:65px;" index="statistics">分析统计</el-menu-item>
								</el-menu-item-group>
							</el-submenu> -->
							<div style="position:relative;top:40px;left:20px;cursor: pointer" v-on:click="logout">
								<span style="font-size:14px;color:#F66B3D;font-weight:bold;">退出登录</span>
							</div>
				</el-menu>
				
			</aside>
			
			<section class="content-container" v-if="path!='/integral'">
				<div class="grid-content bg-purple-light">
					<!-- <el-col :span="24" class="breadcrumb-container">
						<strong class="title"><i class="iconfont icon-untitled21"></i>{{$route.name}}</strong>
  					<el-button v-show="showGoback" type="info" plain size="mini" class="goback" @click="$router.back(-1)">返回</el-button>
					</el-col> -->
					<el-col :span="24" class="content-wrapper" >
						<transition name="fade" mode="out-in" >
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
			<section v-else class="section-class">
							<router-view></router-view>
			</section>
		</el-col>
	</el-row>
</template>

<script>
	import {API__code,API__account } from '../api/index.js'
	export default {
		data() {
			return {
				company_log:'',
				company_name:'',
				sysUserName: '',
				company:'',
				point:'',
				photo:'',
				token:'',
				checkCode:'',
				id:'',
				userShows:false,
				adminShows:false,
				sysName:'狄诺尼云',
				collapsed:false,
				sysUserAvatar: '',
				routesd:[],
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				currentPath:  this.$route.path.split('/')[1],
				showGoback: false, // 是否显示返回按钮
				companymanageid:'',

				deptList: [],     // 当前登录人管理的用户列表
				path:''
			}
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function (a, b) {
			},
			// 处理是否显示返回按钮
			handleGoback() {
				this.path = this.$route.path
				this.currentPath =  this.$route.path.split('/')[1];
				if(this.currentPath == 'companyAll'){ //每次从菜单栏点企业管理，都加载第一个企业用户界面
					sessionStorage.setItem('admin_menu', '1');
				}
				if(this.$route.matched[this.$route.matched.length-1].path.indexOf('/:id') > -1) 
					this.showGoback = true;
				else 
					this.showGoback = false;
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					sessionStorage.removeItem('module');
					_this.$router.push('/login');
					_this.setCookie("dnnyptInfo","dnnypt_checkCode","");
					_this.setCookie("dnnyptInfo","dnnypt_id","");
					sessionStorage.clear();
				}).catch(() => {
					
				});
			},
			setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        if(c_name == "dnnyptInfo"){
          window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
        }
      },
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
			//读取cookie
			getCookie: function() {
				this.id = sessionStorage.getItem('dnnypt_id');
				if (document.cookie.length > 0) {
						var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
						for (var i = 0; i < arr.length; i++) {
								var arr2 = arr[i].split('='); //再次切割
								//判断查找相对应的值
								if (arr2[0] == 'dnnypt_token') {
										this.token = arr2[1]; //保存到保存数据的地方
								} else if (arr2[0] == 'dnnypt_checkCode') {
										this.checkCode = arr2[1];
								}
								//  else if (arr2[0] == 'dnnypt_id') {
								// 		this.id = arr2[1];
								// }
						}
				}
			},
			getDetial:function(){
				let _this = this;
				let params = {
					token:this.token,
					checkCode:this.checkCode,
					id:sessionStorage.getItem('dnnypt_id'),
				}
				API__account.accountDetail(params)
				.then((res)=>{
					if(res.data.code == API__code.SUCCESS){
						_this.company_name = res.data.data.showname;
						_this.company_log = res.data.data.pic;
						if(res.data.data.companymanageid){
							_this.companymanageid = res.data.data.companymanageid;
							
              sessionStorage.setItem('companymanageid', res.data.data.companymanageid);
             
						}

						// 当前登录人管理的部门列表
						_this.deptList = res.data.data.deptList || [];
							sessionStorage.setItem('deptList', JSON.stringify(_this.deptList));
					}else{
						this.$message.error(res.data.message);
						if(res.data.code == 403){
							this.$router.push({path: 'login'});
						}
					}
				}).catch(err =>{
					this.$message.error('数据丢失，试试重新登陆！');
				});
			},
			
		},
		mounted() {
			this.getDetial();
			if(!this.token && !this.checkCode){
				this.$message.error('请登陆！');
				this.$router.push({path: 'login'});
			}
			this.checkStr = this.$route.query.checkStr;
			this.userID = this.$route.query.userID;
			
			let user = sessionStorage.getItem('user');
			// this.companymanageid = sessionStorage.getItem('companymanageid');
			this.company = sessionStorage.getItem('company');
			this.point = sessionStorage.getItem('point');
			let photos = sessionStorage.getItem('photo');
			if (user) {
				// user = JSON.parse(user);
				this.sysUserName = user;
				//this.sysUserAvatar = user.avatar || '';
			}else{
				this.$message.error('请先登陆！');
				this.$router.push({path: 'login'});
			}
			if(photos){
				this.photo =  photos;
				// this.photo = "http://106.14.238.88:8080/dnnCloud/" + photos;
			//	this.photo = "http://192.168.100.230:8080/dnnCloud/" + photos;
				// this.photo = photos;
				this.$nextTick(() => {
					document.getElementById('sz').style.backgroundImage = "url("+this.photo+")";
				});
			}
			this.handleGoback();
		},
		created(){
			this.getCookie();
		},
		watch: {
			'$route': 'handleGoback',
		}
	}

</script>
<style lang="scss">
	@import '../assets/vars.scss';
	.el-menu-item.is-active{
		color: #F66B3D;
	}
	.el-menu-item, .el-submenu__title{
		color:#333;
	}
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			// background: $color-primary;
			background: #333;
			font-family: "Microsoft YaHei";
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//width:230px;
				height:60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				img {
					width: 40px;
					float: left;
					margin: 9px;
				}
				span{
					float: left;
					line-height: 60px;
					font-size: 28px;
					font-weight: 600;
					b{
						margin-right: 10px;
						font-size: 24px;
					}
				}
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			// top: 60px;
			top: 0px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				// 菜单
				.el-submenu__title{
					color: #fff;
					&:hover{
						background: #333;
					}
				}
				.el-menu{
					height: 100%;
					background: #fff;
					.el-submenu{
						background: #fff;
						.el-menu{
							background: #505050;
							.el-menu-item{
								color: #fff;
								&:hover{
									background: #333;
								}
							}
						}
					}
				}
				// 当前菜单
				.is-active{
					.el-submenu__title{
						border-left: 5px solid $color-primary;
					}
					.el-menu{
						.el-menu-item{
							color: #fff;
							&.is-active{
								color: $color-primary;
								&:link,&:visited,&:hover,&:active,&:focus{
									background: #333;
								}
							}
						}
					}
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}
				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
				width: 230px;
				background: #fff;
			//	overflow-y: overlay;
				// 滚动条
				&::-webkit-scrollbar {
					width: 3px;
					// background: #333;
				}
				&::-webkit-scrollbar-thumb {
					border-radius: 10px;
					background: #ffffff40;
				 }
			}

			.section-class{
				background: #F0F0F0;
				flex:1;
				overflow: auto;
			}
			.content-container {
				background: #F0F0F0;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				.breadcrumb-container {
					//margin-bottom: 15px;
					// background: #eef1f6;
					// border-bottom: 1px solid #d1dae8;
					line-height: 40px;
					padding-left: 20px;
					box-sizing: border-box;
					.iconfont{
						margin-right: 5px;
					}
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #F0F0F0;
					box-sizing: border-box;
					padding: 20px;
				}
			}
		}
	}
	.sz{
		width:32px;
		height: 32px;
   	background: url('./img/yh.png');
    position: absolute;
		right: -10px;
		top: -20px;
	}
	// 返回按钮
	.goback {
		float: right;
		margin: 7px 20px 0 0;
	}
	.div_img{
		background: #eef1f6;
		position: fixed;
		width:400px;
		height: 400px;
		left: 0;
		right: 0;
		margin:0 auto;
		z-index: 19999;
		top:25%;
	}
	.img_div{
		width:90%;
		height:90%;
		position:relative;
		left:5%;
		top:5%;
	}
	.el_rows{
		width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.3;
		z-index: 19998;
	}
	.icon_span{
		position:relative;
		left:13px;
		font-size: 14px;
		font-weight: normal;
		font-family: "思源黑体 CN Bold Bold";
	}
	.top_user{
		text-align: center;
    background: #eef1f6;
    position: relative;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: -5px;
    font-size: 20px;
	}
	.top_name{
		position:relative;
		left:30px;
		width:150px;
		overflow:  hidden;
	}
	.name_user{
		width:107px;
		display:inline-block;
		float: left;
	}
	.el-menu-item-group__title{
		display: none;
	}

	.logo_img{
		// height:36px;
		width:36px;
		position:absolute;
		left:36px;
		top:14px;
	}
	.logo_span{
		position:absolute;
		left:83px;
		top:15px;
		font-size:24px;
		color:#fff;
		font-family: "思源黑体 CN Bold Bold";
		font-weight: bold;
	}
	.home_img{
		width: 64px;
    // height: 64px;
    position: relative;
    top: 20px;
	}
	.home_span{
		font-family: "思源黑体 CN Bold Bold";
		font-size: 18px;
		font-weight: normal;
		color: #333;
    position: relative;
    top: 35px;
	}
	.home_company{
		font-family: "思源黑体 CN Bold Bold";
		font-size: 14px;
		font-weight: normal;
		color: #999;
    position: relative;
    top: 50px;
	}
	.home_point{
		font-family: "思源黑体 CN Bold Bold";
		font-size: 20px;
		font-weight: normal;
		color: #F66B3D;
    position: relative;
    top: 65px;
	}
	.home_point1{
		font-family: "思源黑体 CN Bold Bold";
		font-size: 14px;
		font-weight: normal;
		color: #F66B3D;
    position: relative;
    top: 64px;
	}
	.cygn{
		height:46px;
		border:1px #EFF0F2 solid;
		background:#fff;
		color:#666;
		font-size:14px;
		font-weight:bold;
		line-height: 3;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?363990ce